@if (data && resourcesData) {
  <resources [data]="resourcesData"></resources>
}
